import JobPage from './JobPage';

export default JobPage;
